import React from "react"
import Time from "Components/Table/Time"
import AdPlace from "../OpLog/AdPlace"
import Status from "Components/Material/Status"

export const MplColumns = {
    wechat: [
        {
            title: "ID", field: "id", sorting: false,
        },
        {
            title: "内容", field: "content", sorting: false, cellStyle: { maxWidth: 300, wordBreak: "break-all" },
        },
        {
            title: "时间", field: "ad_time",
            render: (props: any) => {
                if (props.is_draft) {
                    return null
                }
                return (<Time time={props.ad_time} formatStr="YYYY/MM/DD" />)
            },
        },
        {
            title: "位置", field: "ad_place", sorting: false,
            render: (props: any) => (<AdPlace {...props} />),
        },
        {
            title: "标题", field: "title", sorting: false,
            cellStyle: { maxWidth: 300, wordBreak: "break-all" },
        },
        {
            title: "状态", field: "status",
            render: (props: any) => (<Status status={props.status} />),
        },
        {
            title: "作者", field: "author_name", sorting: false,
            cellStyle: { maxWidth: 200, wordBreak: "break-all" },
        },
        {
            title: "负责人", field: "principal", sorting: false,
            render: (props: any) => (<div>{props.principal.nickname || props.creator.nickname}</div>),
        },
    ],
    weibo: [
        {
            title: "ID", field: "id", sorting: false,
        },
        {
            title: "内容", field: "content", sorting: false, cellStyle: { maxWidth: 300, wordBreak: "break-all" },
        },
        {
            title: "时间", field: "ad_time",
            render: (props: any) => {
                if (props.is_draft) {
                    return null
                }
                return (<Time time={props.ad_time} formatStr="YYYY/MM/DD" />)
            },
        },
        {
            title: "位置", field: "ad_place", sorting: false,
            render: (props: any) => {
                if (props.is_draft) {
                    return "备选列表"
                }
                return <AdPlace {...props} />
            },
        },
        {
            title: "标题", field: "title", sorting: false,
            cellStyle: { maxWidth: 300, wordBreak: "break-all" },
        },
        {
            title: "状态", field: "status",
            render: (props: any) => (<Status status={props.status} />),
        },
        {
            title: "作者", field: "author_name", sorting: false,
            cellStyle: { maxWidth: 200, wordBreak: "break-all" },
        },
        {
            title: "负责人", field: "creator", sorting: false,
            render: (props: any) => (<div>{props.creator.nickname || ""}</div>),
        },
    ],
    childCalendar: [
        {
            title: "ID", field: "id", sorting: false,
        },
        {
            title: "内容", field: "content", sorting: false, cellStyle: { maxWidth: 300, wordBreak: "break-all" },
        },
        {
            title: "时间", field: "ad_time",
            render: (props: any) => {
                if (props.is_draft) {
                    return null
                }
                return (<Time time={props.ad_time} formatStr="YYYY/MM/DD" />)
            },
        },
        {
            title: "位置", field: "ad_place", sorting: false,
            render: (props: any) => {
                if (props.is_draft) {
                    return "备选列表"
                }
                return <AdPlace {...props} />
            },
        },
        {
            title: "标题", field: "title", sorting: false,
            cellStyle: { maxWidth: 300, wordBreak: "break-all" },
        },
        {
            title: "状态", field: "status",
            render: (props: any) => (<Status status={props.status} />),
        },
        {
            title: "作者", field: "author_name", sorting: false,
            cellStyle: { maxWidth: 200, wordBreak: "break-all" },
        },
        {
            title: "负责人", field: "creator", sorting: false,
            render: (props: any) => (<div>{props.creator.nickname || ""}</div>),
        },
    ],

    child: [
        {
            title: "ID", field: "id", sorting: false,
        },
        {
            title: "内容", field: "content", sorting: false, cellStyle: { maxWidth: 300, wordBreak: "break-all" },
        },
        {
            title: "时间", field: "ad_time",
            render: (props: any) => {
                if (props.is_draft) {
                    return null
                }
                return (<Time time={props.ad_time} formatStr="YYYY/MM/DD" />)
            },
        },
        {
            title: "位置", field: "ad_place", sorting: false,
            render: (props: any) => {
                if (props.is_draft) {
                    return "备选列表"
                }
                return <AdPlace {...props} />
            },
        },
        {
            title: "标题", field: "title", sorting: false,
            cellStyle: { maxWidth: 300, wordBreak: "break-all" },
        },
        {
            title: "状态", field: "status",
            render: (props: any) => (<Status status={props.status} />),
        },
        {
            title: "作者", field: "author_name", sorting: false,
            cellStyle: { maxWidth: 200, wordBreak: "break-all" },
        },
        {
            title: "负责人", field: "creator", sorting: false,
            render: (props: any) => (<div>{props.creator.nickname || ""}</div>),
        },
    ],
    web: [],
    videoCalendar: [],
    photo: [
        {
            title: "ID", field: "id", sorting: false,
        },
        {
            title: "内容", field: "content", sorting: false, cellStyle: { maxWidth: 300, wordBreak: "break-all" },
        },
        {
            title: "时间", field: "ad_time",
            render: (props: any) => {
                if (props.is_draft) {
                    return null
                }
                return (<Time time={props.ad_time} formatStr="YYYY/MM/DD" />)
            },
        },
        {
            title: "位置", field: "ad_place", sorting: false,
            render: (props: any) => {
                if (props.is_draft) {
                    return "备选列表"
                }
                return <AdPlace {...props} />
            },
        },
        {
            title: "标题", field: "title", sorting: false,
            cellStyle: { maxWidth: 300, wordBreak: "break-all" },
        },
        {
            title: "状态", field: "status",
            render: (props: any) => (<Status status={props.status} />),
        },
        {
            title: "作者", field: "author_name", sorting: false,
            cellStyle: { maxWidth: 200, wordBreak: "break-all" },
        },
        {
            title: "负责人", field: "creator", sorting: false,
            render: (props: any) => (<div>{props.creator.nickname || ""}</div>),
        },
    ],
    beauty: [],
    species: [
        {
            title: "ID", field: "id", sorting: false,
        },
        {
            title: "预约说明", field: "content", sorting: false, cellStyle: { maxWidth: 300, wordBreak: "break-all" },
        },
        {
            title: "时间", field: "ad_time",
            render: (props: any) => {
                if (props.is_draft) {
                    return null
                }
                return (<Time time={props.ad_time} formatStr="YYYY/MM/DD" />)
            },
        },
        {
            title: "位置", field: "ad_place", sorting: false,
            render: (props: any) => {
                if (props.is_draft) {
                    return "备选列表"
                }
                return <AdPlace {...props} />
            },
        },
        {
            title: "标题", field: "title", sorting: false,
            cellStyle: { maxWidth: 300, wordBreak: "break-all" },
        },
        {
            title: "状态", field: "status",
            render: (props: any) => (<Status status={props.status} />),
        },
        {
            title: "作者", field: "author_name", sorting: false,
            cellStyle: { maxWidth: 200, wordBreak: "break-all" },
        },
        {
            title: "预约人", field: "creator", sorting: false,
            render: (props: any) => (<div>{props.creator.nickname || ""}</div>),
        },
    ],
    eat: [],
    health: [
        {
            title: "ID", field: "id", sorting: false,
        },
        {
            title: "预约说明", field: "content", sorting: false, cellStyle: { maxWidth: 300, wordBreak: "break-all" },
        },
        {
            title: "时间", field: "ad_time",
            render: (props: any) => {
                if (props.is_draft) {
                    return null
                }
                return (<Time time={props.ad_time} formatStr="YYYY/MM/DD" />)
            },
        },
        {
            title: "位置", field: "ad_place", sorting: false,
            render: (props: any) => {
                if (props.is_draft) {
                    return "备选列表"
                }
                return <AdPlace {...props} />
            },
        },
        {
            title: "标题", field: "title", sorting: false,
            cellStyle: { maxWidth: 300, wordBreak: "break-all" },
        },
        {
            title: "状态", field: "status",
            render: (props: any) => (<Status status={props.status} />),
        },
        {
            title: "作者", field: "author_name", sorting: false,
            cellStyle: { maxWidth: 200, wordBreak: "break-all" },
        },
        {
            title: "预约人", field: "creator", sorting: false,
            render: (props: any) => (<div>{props.creator.nickname || ""}</div>),
        },
    ],
}

export const MplTableTitle = "物料审查"
